import { useMutation } from "react-query";
import { completeTasks } from "../../taskState";

export const useCompleteTasks = () => {
    return useMutation(({ selectedProducts, reject = false, sourcePage, action }) => {
        const hideErrors = sourcePage === "photography";
        const createPayload = () => {
            if (reject) {
                return selectedProducts.map(({ key }) => ({
                    taskKey: key,
                    state: "completed",
                    data: "rejected",
                    force: true,
                }));
            }

            return selectedProducts.map((product) => {
                if (product.context.imagesNeedClientApproval && !product.isAwaitingClientApproval && sourcePage == "imageeditingqa") {
                    return {
                        taskKey: product.key,
                        state: "waiting-for-ca",
                        data: "sentForCA",
                        force: true,
                    };
                }

                if (product.isAwaitingClientApproval && sourcePage == "imageeditingqa") {
                    return {
                        taskKey: product.key,
                        state: "completed",
                        data: "clientApproved",
                        force: true,
                    };
                }

                return {
                    taskKey: product.key,
                    state: "completed",
                    force: true,
                };
            });
        };

        return completeTasks(createPayload(), sourcePage, reject ? "reject" : "complete", hideErrors);
    });
};
